<div class="routing-position-editor" [formGroup]="form">

  <div style="grid-column: 1; grid-row: 1;">
    <sc-flex centered>
      <sc-string-field style="align-self: center" formControlName="stationName" labelDictionaryKey="tmc.transport.routing.routingPosition.stationName"></sc-string-field>
      <sc-content-spacer></sc-content-spacer>
      <!-- <sc-button iconClass="fa-sitemap" primary [disabled]="form.disabled" (click)="assignStation()"></sc-button> -->
      <button mat-icon-button style="align-self: center; height: 60px" [disabled]="form.disabled"  (click)="assignStation()">
        <sc-icon iconClass="fa-sitemap fa-2x"></sc-icon>
      </button>
      <sc-content-spacer></sc-content-spacer>
    </sc-flex>
  </div>

  <sc-select-field formControlName="actionType" [data]="availableActionTypes" style="grid-column: 2; grid-row: 1;"
    labelDictionaryKey="tmc.transport.routing.routingPosition.actionType"></sc-select-field>

  <div style="grid-column: 3; grid-row: 1;">
    <sc-content-spacer></sc-content-spacer>
    <!-- <sc-button iconClass="fa-tasks" primary [disabled]="form.disabled" (click)="assignTasks()"></sc-button> -->
    <button mat-icon-button style="align-self: center; height: 60px" [disabled]="form.disabled" (click)="assignTasks()">
      <sc-icon iconClass="fa-tasks fa-2x"></sc-icon>
    </button>
    <sc-content-spacer></sc-content-spacer>
  </div>

  <sc-string-field formControlName="cargo" style="grid-row: 2;"
    labelDictionaryKey="tmc.transport.routing.routingPosition.cargo"></sc-string-field>

  <sc-checkbox-field formControlName="waitingForRetrieve" style="grid-column: 2; grid-row: 2;align-self: center; height: 60px"
    labelDictionaryKey="tmc.transport.routing.routingPosition.waitingForRetrieve"></sc-checkbox-field>

  <sc-string-field formControlName="predictedDuration" style="grid-column: 3; grid-row: 2;"
    labelDictionaryKey="tmc.transport.routing.routingPosition.predicted-duration"></sc-string-field>

  <sc-select-field formControlName="stationAssignmentStrategy" style="grid-column: 1; grid-row: 3;"
    [data]="availableStationAssignmentStrategyOptions"
    labelDictionaryKey="tmc.common.entity.station-assignment-strategy"></sc-select-field>

  <sc-string-field formControlName="hint" style="grid-column: 2 / span 3; grid-row: 3;"
    labelDictionaryKey="tmc.transport.routing.routingPosition.hint"></sc-string-field>


</div>
